import {getNoticeDetail} from '../service/home';

export const state = {
  theme: 1,
  load: false,
  notice: {
    state: true,
    info: {}
  },
  ckboxflag:0,
  inputnum:"",
};

export const mutations = {
  SWITCH_THEME(state, theme) {
    state.theme = theme;
  },
  SET_LOAD_STATE(state, load) {
    state.load = load;
  },
  SET_NOTICE_INFO(state, info) {
    state.notice.info = info;
  }
};

export const actions = {
  // 获取通知详情
  async loadNoticeDetail({state, commit}, id) {
    // loading
    if (!id) return;
    const info = await getNoticeDetail(id);
    if (info.result === 'ok') {
      commit('SET_NOTICE_INFO', info.data);
    }
  }
};

export const getters = {};



// WEBPACK FOOTER //
// ./src/store/application.js